/**
 * Configuration file for compliance components
 */

// API base URL - in production, this would come from environment variables
export const API_BASE_URL = 'http://127.0.0.1:6969';

// API endpoints
export const API_ENDPOINTS = {
  // Infrastructure endpoints
  INFRASTRUCTURE: {
    AWS_REGIONS: '/api/infrastructure/aws-regions',
    CONFIG: '/api/infrastructure/config',
    RUN_TESTS: '/api/infrastructure/run-tests',
    REMEDIATE: '/api/infrastructure/remediate',
    TEST_DETAILS: '/api/infrastructure/test-details',
    AVAILABLE_CHECKS: '/api/infrastructure/available-checks',
    ALL_TEST_RESULTS: '/api/infrastructure/all-test-results'
  },
  // Code security endpoints
  CODE: {
    TRIGGER_PIPELINE: '/api/code/trigger-pipeline',
    PIPELINE_STATUS: '/api/code/pipeline-status',
    CODE_QUALITY_REPORT: '/api/code/code-quality-report',
    ESLINT_CODE_QUALITY_REPORT: '/api/code/eslint-code-quality-report',
    SAST_REPORT: '/api/code/sast-report',
    SECRET_DETECTION_REPORT: '/api/code/secret-detection-report',
    DEPENDENCY_SCANNING_REPORT: '/api/code/dependency-scanning-report',
    DAST_REPORT: '/api/code/dast-report',
    API_UNIT_TESTS_REPORT: '/api/code/api-unit-tests-report',
    ADD_REMEDIATION: '/api/code/add-remediation'
  },
  // Health check endpoints
  HEALTH: {
    PUBLIC: '/public/health',
    API: '/api/health'
  }
};

// Request configuration
export const REQUEST_CONFIG = {
  // Add authorization headers for protected endpoints
  getAuthHeaders: () => {
    // In a real implementation, this would get the JWT token from Cognito
    // For now, we're returning an empty object
    return {};
  },
  
  // Default request timeout in milliseconds
  timeout: 120000
};

// Compliance frameworks supported by the application
export const COMPLIANCE_FRAMEWORKS = [
  'SOC 2',
  'ISO 27001',
  'GDPR',
  'HIPAA',
  'AWS Well-Architected Framework'
];
